export const MODAL_CLOSE_ANIMATION_DURATION = 300;

export default { MODAL_CLOSE_ANIMATION_DURATION };
